<template>
  <v-card-text class="inserted-values px-9 pt-3">
    <v-row>
      <v-col cols="3" class="request-label">
        Požadovaný termín zahájení
      </v-col>

      <v-col cols="3" class="request-value">
        {{ dateFormatting(individualBillingException.startDate) || missingValueString }}
      </v-col>

      <v-col
        cols="12"
        lg="6"
        class="request-value text-right"
        v-if="individualBillingException.changedStartDate"
      >
        <v-icon color="orange" align-center>
          mdi-alert
        </v-icon>

        <span class="ml-1">
          Termín zahájení byl změněn na
          {{ dateFormatting(individualBillingException.changedStartDate) || missingValueString }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Požadovaný termín ukončení
      </v-col>

      <v-col cols="3" class="request-value">
        {{ dateFormatting(individualBillingException.endDate) || missingValueString }}
      </v-col>

      <v-col
        cols="12"
        lg="6"
        class="request-value text-right"
        v-if="individualBillingException.changedEndDate"
      >
        <v-icon color="orange" align-center>
          mdi-alert
        </v-icon>

        <span class="ml-1">
          Termín ukončení byl změněn na
          {{ dateFormatting(individualBillingException.changedEndDate) || missingValueString }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Telefon
      </v-col>

      <v-col cols="9" class="request-value">
        {{ formatPhoneNumber(individualBillingException.phone) || missingValueString }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        E-mail
      </v-col>

      <v-col cols="9" class="request-value">
        {{ individualBillingException.email || missingValueString }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Výjimka z překročení RK
      </v-col>

      <v-col cols="9" class="request-value">
        {{ checkTrueFalse(individualBillingException.exceedingReservedCapacity) }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3" class="request-label">
        Výjimka z nedodržení účiníku
      </v-col>

      <v-col cols="9" class="request-value">
        {{ checkTrueFalse(individualBillingException.exceedingPowerFactor) }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3" class="request-label">
        Výjimka za nevyžádanou dodávku jalové energie
      </v-col>

      <v-col cols="9" class="request-value">
        {{ checkTrueFalse(individualBillingException.reactivePowerSupply) }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3" class="request-label">
        Výjimka z překročení RP
      </v-col>

      <v-col cols="9" class="request-value">
        {{ checkTrueFalse(individualBillingException.exceedingReservedPower) }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Příloha
      </v-col>

      <v-col cols="9" class="request-value">
        <a
          v-if="file && file.url"
          :href="file.url"
          @click.prevent="fileDownload($event, 'file')"
        >
          {{ file.name || missingValueString }}
        </a>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Poznámka
      </v-col>

      <v-col cols="9" class="request-value">
        {{ individualBillingException.note || missingValueString }}
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { downloadFile } from '@/components/mixins/downloadFile';
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber';

export default {
  name: 'IndividualBillingExceptionInsertedValues',
  mixins: [downloadFile, formatPhoneNumber],
  props: {
    individualBillingException: {
      type: Object,
      required: false,
      startDate: null,
      endDate: null,
    },
    file: {
      type: Object,
      required: false,
    },
  },
  methods: {
    fileDownload(event) {
      this.downloadFile(event, `requests/files/${this.file.uuid}`);
    },
    checkTrueFalse(data) {
      return data ? 'Ano' : 'Ne';
    },
  },
};
</script>
